import _ from 'lodash';
import PropTypes from 'prop-types';
import { SVG_PROP_TYPE } from '../vectorImage/constants';
import SIZES_JSON from '../iconography/iconography_sizes.json';
export var ICON_TYPES_PAYMENT = ['discover', 'affirm', 'amex', 'android-pay', 'apple-pay', 'bancontact', 'boleto', 'google-wallet', 'ideal', 'jcb', 'maestro', 'mastercard', 'moneris', 'pagofacil', 'paypal-bank', 'paypal', 'rapipago', 'sepa', 'sofort', 'visa-debit', 'visa', 'oxxo', 'elo', 'hipercard'];
export var PAYMENT_ICON_SIZES = _.chain(SIZES_JSON).keys().filter(function (size) {
  return size.indexOf('payment-') >= 0;
}).map(function (size) {
  return size.replace('payment-icon-height-', '').replace('payment-icon-width-', '');
}).uniq().value();
export var PAYMENT_TYPE_PROP_TYPE = SVG_PROP_TYPE;
export var PAYMENT_SIZE_PROP_TYPE = PropTypes.oneOf(PAYMENT_ICON_SIZES);